<template>
  <v-app id="app" ref="appRef" class="my-app" :class="isInDarkMode ? 'dark' : 'light'">
    <dialog-loader id="dialogLoader" ref="refDialogLoader" />
    <highlighter id="highlighter" ref="refHighlighter" />
    <!-- <modal-google-map-view /> -->
    <v-dialog class="ma-0 pa-0" v-model="dialog.modal_google_map" v-if="dialog.modal_google_map" width="unset" height="auto" persistent transition="nice-modal-fade">
      <google-map-view />
    </v-dialog>
    <v-dialog class="ma-0 pa-0" v-model="dialog.modal_receipt_view" v-if="dialog.modal_receipt_view" width="unset" height="auto" persistent transition="nice-modal-fade">
      <receipt-view />
    </v-dialog>
    <v-dialog v-model="dialog.modal_invoice" v-if="dialog.modal_invoice" :width="840" :height="800" class="ma-0 pa-0 customscroll">
      <invoice-view />
    </v-dialog>
    <v-dialog v-model="dialog.modal_picker_view" v-if="dialog.modal_picker_view" width="unset" :min-height="200" class="ma-0 pa-0" persistent>
      <picker-view />
    </v-dialog>
    <v-dialog v-model="dialog.modal_date_picker" v-if="dialog.modal_date_picker" width="300" :min-height="200" class="ma-0 pa-0" persistent>
      <t-date-picker />
    </v-dialog>
    <v-dialog v-model="dialog.modal_yes_no" v-if="dialog.modal_yes_no" width="unset" :min-height="200" class="ma-0 pa-0" max-width="500px" persistent>
      <yes-no-dialog />
    </v-dialog>
    <v-dialog v-model="dialog.modal_filter" v-if="dialog.modal_filter" :min-width="300" :min-height="200" persistent max-width="700px" height="auto">
      <filter-view />
    </v-dialog>
    <v-dialog v-model="dialog.modal_captcha" v-if="dialog.modal_captcha" width="330px" :min-height="200" class="ma-0 pa-0" max-width="550px" persistent>
      <t-captcha />
    </v-dialog>
    <v-dialog style="z-index: 999999" v-model="dialog.modal_loader" v-if="dialog.modal_loader" width="unset" :min-height="200" class="ma-0 pa-0" persistent>
      <loading-view />
    </v-dialog>
    <v-dialog style="z-index: 999999" v-model="dialog.modal_device_edit" v-if="dialog.modal_device_edit" width="unset" :min-height="editDeviceItemHeight - 8" class="ma-0 pa-0">
      <div style="overflow: hidden" class="ma-0 pa-0">
        <DeviceInformationSingle :device="dialog.data" :editMode="true" />
      </div>
    </v-dialog>

    <router-view id="mainRooterView" class="ma-0 pa-0 routercontainer" />
    <!-- <LogoLoader></LogoLoader> -->
    <div v-if="booleans.isLoading" class="rotatinglogocontainer" style="position: absolute; width: 100%; height: 100%">
      <div class="rotatinglogobackground" style="position: absolute; width: 100%; height: 100%"></div>
      <img :src="Logo" width="200px" height="200px" class="rotatinglogo" />
    </div>
  </v-app>
</template>

<script>
// import ModalGoogleMapView from "./components/Controls/ModalGoogleMapView";
import GoogleMapView from "./components/Controls/GoogleMapView";
import DialogLoader from "./components/Controls/LoaderView.vue";
import Highlighter from "./components/Controls/HighLighter";
import ReceiptView from "./components/Controls/ReceiptView";
import PickerView from "./components/Controls/PickerView";
import TDatePicker from "./components/Controls/TDatePicker";
import YesNoDialog from "./components/Controls/YesNoDialog";
import FilterView from "./components/Controls/Filters/FilterView";
import InvoiceView from "./components/Controls/InvoiceView";
import LoadingView from "./components/Controls/LoadingView";
import TCaptcha from "./components/Controls/TCaptcha";
import DeviceInformationSingle from "./components/Devices/DeviceInformationSingle";
// import LogoLoader from "./components/Controls/LogoLoader";

import DataManager from "./js/DataManager";

export default {
  name: "App",
  components: {
    // ModalGoogleMapView,
    GoogleMapView,
    DialogLoader,
    Highlighter,
    ReceiptView,
    PickerView,
    TDatePicker,
    YesNoDialog,
    TCaptcha,
    FilterView,
    InvoiceView,
    LoadingView,
    DeviceInformationSingle,
    //LogoLoader,
  },
  data() {
    return {
      Logo: require("./assets/img/main/darkLogo.png"),
    };
  },
  methods: {},
  computed: {},
  created() {},
  mounted() {},
  updated() {},
  unmounted() {
    DataManager.__clean();
  },
};
</script>

<style>
html {
  overflow: hidden;
}

body {
  overflow: hidden;
}

.routercontainer {
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.maincontainer {
  position: fixed;
  overflow: hidden;
}

/* .application {
height: 100%;
} */

/* main {
height: calc(100% - 56px - 36px);
} */
.centered-input,
.centered-input label,
.centered-input input,
.centered-input v-input__control v-input__slot v-text-field__slot label {
  text-align: center;
}

.centered-input .v-select__selection {
  width: 100%;
  justify-content: center;
  text-align: center;
}

.centered-input input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.centered-input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.centered-input input::-webkit-outer-spin-button,
.centered-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  display: none;
  margin: 0;
}

.centered-input::-webkit-outer-spin-button,
.centered-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

.component-container-light {
  background-color: #fff;
  color: #000;
}

.component-container-dark {
  background-color: #222;
  color: #fff;
}

.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
* {
  text-transform: none !important;
}

.light .v-virtual-scroll,
.light .row-content,
.light .v-menu__content,
.light .customscroll {
  overflow-y: auto;
  scrollbar-color: rgb(170, 170, 170) rgb(238, 238, 238);
}

.dark .v-virtual-scroll,
.dark .row-content,
.dark .v-menu__content,
.dark .customscroll {
  overflow-y: auto;
  scrollbar-color: #111 #666;
}

.light ::-webkit-scrollbar {
  /* width */
  width: 12px;
  height: 12px;
}
/* button */
/* .light ::-webkit-scrollbar-button {
    background: #555;
} */
.light ::-webkit-scrollbar-thumb {
  /* Handle */
  background: rgb(136, 136, 136);
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgb(119, 119, 119);
  box-shadow: inset 0 0 6px rgb(119, 119, 119);
}
.light ::-webkit-scrollbar-thumb:hover {
  /* Handle on hover */
  background: rgb(153, 153, 153);
}
.light ::-webkit-scrollbar-corner {
  /* Corner */
  background: rgb(170, 170, 170);
}
.light ::-webkit-resizer {
  /* Resizer */
  background: rgb(170, 170, 170);
}
.light ::-webkit-scrollbar-track {
  /* Track */
  background: #ddd;
}
/* The track NOT covered by the handle.
::-webkit-scrollbar-track-piece {
    background: #000;
} */

.dark ::-webkit-scrollbar {
  /* width */
  width: 12px;
  height: 12px;
}
/* button */
/* .dark ::-webkit-scrollbar-button {
    background: #444; 
}*/
.dark ::-webkit-scrollbar-thumb {
  /* Handle */
  background: #666;
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(51, 51, 51, 0.5);
  box-shadow: inset 0 0 6px rgba(51, 51, 51, 0.5);
}
.dark ::-webkit-scrollbar-thumb:hover {
  /* Handle on hover */
  background: #555;
}
.dark ::-webkit-scrollbar-corner {
  /* Corner */
  background: #888;
}
.dark ::-webkit-resizer {
  /* Resizer */
  background: #888;
}
.dark ::-webkit-scrollbar-track {
  /* Track */
  background: #888;
}
/* The track NOT covered by the handle.
::-webkit-scrollbar-track-piece {
    background: #000;
} */

.box-container {
  display: flex;
  overflow: hidden;
  flex-flow: column;
  height: 100%;
}

.box-container-horizontal {
  display: flex;
  overflow: hidden;
  flex-flow: row;
  width: 100%;
}

.box-container .row-header,
.box-container-horizontal .row-header {
  flex: 0 1 0;
  overflow-y: none;
}

.box-container-horizontal .row-header {
  height: 100%;
}

.box-container .row-content,
.box-container-horizontal .row-content {
  flex: 1 1 auto;
  overflow-y: auto;
}

.box-container .row-content-limited,
.box-container-horizontal .row-content-limited {
  flex: 1 1 100;
  overflow-y: auto;
}

.box-container .row-content-horizontal-scroll {
  flex: 1 1 auto;
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  overflow-x: auto;
  overflow-y: none;
}

.animated_background {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  background: #f3f9ff;
}

.custom_hover_shadow {
  transition: box-shadow 0.2s;
}

.custom_hover_shadow:hover {
  box-shadow: 0 0 20px rgba(33, 33, 33, 0.5);
}

.no-background-hover::before {
  background-color: transparent !important;
  cursor: pointer;
}

.text-custom {
  text-align: justify;
  text-justify: inter-word;
  text-indent: 1em;
}

.scroll-left {
  height: 20px;
  overflow: hidden;
  position: relative;
}
.scroll-left p {
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  line-height: 20px;
  text-align: center;
  /* Starting position */
  -moz-transform: translateX(100%);
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
  /* Apply animation to this element */
  -moz-animation: scroll-left 15s linear infinite;
  -webkit-animation: scroll-left 15s linear infinite;
  animation: scroll-left 15s linear infinite;
}
/* Move it (define the animation) */
@-moz-keyframes scroll-left {
  0% {
    -moz-transform: translateX(100%);
  }
  100% {
    -moz-transform: translateX(-100%);
  }
}
@-webkit-keyframes scroll-left {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(-100%);
  }
}
@keyframes scroll-left {
  0% {
    -moz-transform: translateX(100%); /* Browser bug fix */
    -webkit-transform: translateX(100%); /* Browser bug fix */
    transform: translateX(100%);
  }
  100% {
    -moz-transform: translateX(-100%); /* Browser bug fix */
    -webkit-transform: translateX(-100%); /* Browser bug fix */
    transform: translateX(-100%);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>

<style lang="scss">
// #app.my-app.light  {
//     & *  {
//     // color: #4d4e52;
//     // background: #EFFEEF;
//   }
// }

.text-with-effect.dark {
  background: linear-gradient(to right, gray, gray 50%, white 50%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  background-position: 100%;
  transition: background-position 1000ms ease;
  text-decoration: none; // text decorations are clipped in WebKit browsers
  &:hover {
    background-position: 0 100%;
  }
}

.text-with-effect.light {
  background: linear-gradient(to right, gray, gray 50%, black 50%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  background-position: 100%;
  transition: background-position 1000ms ease;
  text-decoration: none; // text decorations are clipped in WebKit browsers
  &:hover {
    background-position: 0 100%;
  }
}

.text-container-with-effect {
  background: linear-gradient(to right, lightskyblue, lightskyblue 50%, transparent 50%);
  background-clip: border-box;
  -webkit-background-clip: border-box;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  background-position: 100%;
  transition: background-position 1000ms ease;
  text-decoration: none; // text decorations are clipped in WebKit browsers
  &:hover {
    background-position: 0 100%;
  }
}

.text-container-with-effect > span .light {
  background: linear-gradient(to right, yellow, yellow 50%, black 50%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  background-position: 100%;
  transition: background-position 1000ms ease;
  text-decoration: none; // text decorations are clipped in WebKit browsers
  &:hover {
    background-position: 0 100%;
  }
}

.text-container-with-effect > span .dark {
  background: linear-gradient(to right, yellow, yellow 50%, white 50%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  background-position: 100%;
  transition: background-position 1000ms ease;
  text-decoration: none; // text decorations are clipped in WebKit browsers
  &:hover {
    background-position: 0 100%;
  }
}

.growing-child-row {
  display: flex;
  flex-direction: row;
  flex: 1;
}

.apexcharts-menu-item.exportCSV {
  display: none;
}

.rotatinglogobackground {
  background-color: white;
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(5px);
  opacity: 1;
}
.rotatinglogocontainer .rotatinglogo {
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  text-align: center;
  z-index: 1;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
}

.rotatinglogo {
  position: relative;
  display: inline-block;
  z-index: 2147483647;
  -moz-animation: rotatinglogo 1s linear infinite;
  -webkit-animation: rotatinglogo 1s linear infinite;
  animation: rotatinglogo 1s linear infinite;
}

@-moz-keyframes rotatinglogo {
  0% {
    -moz-transform: rotate(0deg);
  }
  50% {
    -moz-transform: rotate(90deg) scale(0.7);
  }
  100% {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes rotatinglogo {
  0% {
    -webkit-transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(90deg) scale(0.7);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes rotatinglogo {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(90deg) scale(0.7);
  }
  100% {
    transform: rotate(360deg);
  }
}

.tooltip-top::before {
  border-right: solid 8px transparent;
  border-left: solid 8px transparent;
  transform: translateX(-50%);
  position: absolute;
  z-index: -21;
  content: "";
  top: 100%;
  left: 50%;
  height: 0;
  width: 0;
}
.tooltip-top.error::before {
  border-top: solid 8px #ff6060;
}

.tooltip-top.success::before {
  border-top: solid 8px #1b5e20;
}
.tooltip-top.secondary::before {
  border-top: solid 8px #3f3f3f;
}

.tooltip-top.primary::before {
  border-top: solid 8px #246fb3;
}

.tooltip-top.info::before {
  border-top: solid 8px #2196f3;
}

.tooltip-bottom::before {
  border-right: solid 8px transparent;
  border-left: solid 8px transparent;
  transform: translateX(-50%);
  position: absolute;
  z-index: -21;
  content: "";
  bottom: 100%;
  left: 50%;
  height: 0;
  width: 0;
}

.tooltip-bottom.error::before {
  border-bottom: solid 8px #ff6060;
}

.tooltip-bottom.success::before {
  border-bottom: solid 8px #1b5e20;
}
.tooltip-bottom.secondary::before {
  border-bottom: solid 8px #3f3f3f;
}

.tooltip-bottom.primary::before {
  border-bottom: solid 8px #246fb3;
}

.tooltip-bottom.info::before {
  border-bottom: solid 8px #2196f3;
}

.tooltip-right::before {
  content: " ";
  position: absolute;
  top: 50%;
  right: 100%; /* To the left of the tooltip */
  margin-top: -8px;
  border-width: 8px;
  border-style: solid;
  border-top: solid 8px transparent;
  border-bottom: solid 8px transparent;
  border-left: solid 8px transparent;
}

.tooltip-right.error::before {
  border-right: solid 8px #ff6060 !important;
}

.tooltip-right.success::before {
  border-right: solid 8px #1b5e20 !important;
}
.tooltip-right.secondary::before {
  border-right: solid 8px #3f3f3f !important;
}

.tooltip-right.primary::before {
  border-right: solid 8px #246fb3 !important;
}

.tooltip-right.info::before {
  border-right: solid 8px #2196f3 !important;
}

.tooltip-left::before {
  content: " ";
  position: absolute;
  top: 50%;
  left: 100%; /* To the left of the tooltip */
  margin-top: -8px;
  border-width: 8px;
  border-style: solid;
  border-top: solid 8px transparent;
  border-bottom: solid 8px transparent;
  border-right: solid 8px transparent;
}

.tooltip-left.error::before {
  border-left: solid 8px #ff6060 !important;
}

.tooltip-left.success::before {
  border-left: solid 8px #1b5e20 !important;
}

.tooltip-left.secondary::before {
  border-left: solid 8px #3f3f3f !important;
}

.tooltip-left.primary::before {
  border-left: solid 8px #246fb3 !important;
}

.tooltip-left.info::before {
  border-left: solid 8px #2196f3 !important;
}

.prevent-select {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
  -moz-user-select: none;
}
</style>